import {
    ADD_TO_CART,
    ADD_TO_CART_ERROR,
    ADD_TO_WISHLIST,
    ADD_TO_WISHLIST_RESOLUTION,
    MOVE_TO_WISHLIST_RESOLUTION,
    ADD_WISHLIST_TO_UI,
    ADDED_TO_CART,
    CAN_ADD_TO_LIST,
    CHANGE_COLOR,
    CHANGE_QUANTITY,
    CHANGE_SIZE_TYPE,
    DELETE_UPLOADED_PHOTO,
    EXPAND_IMAGE,
    RECEIVE_REVIEWS,
    RECEIVE_UGC,
    RECEIVE_WRITE_REVIEW_ERRORS,
    RECEIVE_WRITE_REVIEW_FIELDS,
    RECEIVE_WRITE_REVIEW_FIELDS_ERRORS,
    RECEIVE_WRITE_REVIEW_IMAGE_UPLOAD_ERRORS,
    REMOVE_PRODUCT,
    RESET_ADD_TO_CART,
    RESET_PHOTO_UPLOAD_PREVIEW,
    RESET_QUANTITY,
    RESET_SIZE,
    SAVE_FORM_VALIDATION,
    SAVE_PHOTO_UPLOAD_PREVIEW,
    SAVE_BOPIS_POOLS,
    SAVE_PRODUCT,
    SAVE_PRODUCT_ERROR,
    SAVE_REQUEST_SWATCH_SELECTION_ERROR,
    SAVE_REQUEST_SWATCH_SELECTIONS,
    SAVE_WRITE_REVIEW_FORM_DATA,
    SAVE_WRITE_REVIEW_VALIDATION,
    SET_REVIEW_PAGE,
    SHOW_SHIP_TO_STORE_ERROR,
    TOGGLE_NO_STORE_MESSAGE,
    UPDATE_SELECTED_SKU,
    UPDATE_PRODUCT_META,
    UPDATE_REVIEW_PAGES,
    UPDATE_TOTAL_STOCK,
    WRITE_REVIEW_IMAGE_UPLOAD_SUCCESS,
    WRITE_REVIEW_SUCCESS,
    WRITE_REVIEW_AUTOFILL,
    SHOW_PRODUCT_ACTION_ERROR,
    HIDE_PRODUCT_ACTION_ERROR,
    SHOW_CANNOT_ADD_TO_LIST_ERROR,
    HIDE_CANNOT_ADD_TO_LIST_ERROR,
    RESET_WRITE_REVIEW_FORM,
    RESET_ADD_TO_WISHLIST,
    SAVE_REQUEST_SWATCH_FORM_DATA,
    RESET_REQUEST_SWATCH_FORM_DATA,
    RESET_REQUEST_SWATCH_SELECTIONS,
    SET_SELECTED_PRODUCT_FOR_REQUEST_SWATCH,
    BACK_IN_STOCK_VIEW,
    BACK_IN_STOCK_NOTIFICATION_FAILURE,
    ADD_TO_CART_READY,
    RESET_WISHLISTS,
    UPDATE_BOPIS_STOCK_INFO,
    SET_TILE_TYPE_OVERRIDE,
    SET_REQUEST_SWATCH_COUNTRIES
} from '../actions/productActions';

import { BOPIS_CHANGE_STORE_LOAD_STORES,
    BOPIS_CHANGE_STORE_CLEAR,
    BOPIS_CHANGE_STORE_SEARCH_DATA,
    BOPIS_CHANGE_STORE_RESULT_DATA
} from '../actions/bopisChangeStoreActions';

import { SAVE_DEFAULT_URBN_STORE } from '../../../core/js/actions/bopisActions';
import { UPDATE_PRODUCT_REVIEW_STATS } from '../actions/reviewsActions';

import { getBopisState } from '../utils/bopisUtils';
import { merge, mixin } from '../../../core/js/utils/reducerUtils';

import { BEGIN_MTO_ADD_TO_CART } from '../../../mto/js/actions/addToCartActions';

import { SET_BACK_TO_CATALOG_URL } from '../../../core/js/actions/backToCatalogActions';

/* eslint-disable complexity */
/**
 * Product sub-reducer
 *
 * @param {Object} state    Product or sub-product (family product)
 * @param {Object} action   Action to reduce
 * @return {Object}         Newly reduced state
 */
export function productSubReducer(state, action) {
    switch (action.type) {
        case SAVE_PRODUCT:
            return merge(
                state,
                action.payload.product
            );

        case REMOVE_PRODUCT:
            return {};

        case CHANGE_SIZE_TYPE:
        case RESET_SIZE:
        case RESET_QUANTITY:
        case UPDATE_TOTAL_STOCK:
        case BACK_IN_STOCK_VIEW:
            return Object.assign(
                {}, state, {
                    productControls: Object.assign(
                        {}, state.productControls, action.payload
                    )
                }
            );

        case CHANGE_COLOR:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, action.payload.productAddToCart
                    ),
                    productImageViewer: Object.assign(
                        {}, state.productImageViewer, action.payload.productImageViewer
                    ),
                    productDetails: Object.assign(
                        {}, state.productDetails, action.payload.productDetails
                    )
                }
            );

        case SAVE_FORM_VALIDATION:
            return Object.assign(
                {}, state, {
                    productControls: Object.assign(
                        {}, state.productControls, {
                            validation: action.payload.productControls.validation
                        }
                    )
                }
            );

        case RESET_ADD_TO_CART:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            isPending: false,
                            isSuccess: false
                        }
                    )
                }
            );

        case ADD_TO_CART:
        case BEGIN_MTO_ADD_TO_CART:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            isPending: true,
                            isSuccess: false
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: false
                        }
                    )
                }
            );

        case ADD_TO_WISHLIST:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            canAddToCart: false
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: false,
                            isPending: true,
                            isSuccess: false
                        }
                    )
                }
            );

        case RESET_ADD_TO_WISHLIST:
            return Object.assign(
                {}, state, {
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            isPending: false,
                            isSuccess: false
                        }
                    )
                }
            );

        case ADD_WISHLIST_TO_UI:
            return Object.assign(
                {}, state, {
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            wishlists: action.payload
                        }
                    )
                }
            );

        case ADDED_TO_CART:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, {
                            error: null
                        }
                    ),
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            isPending: false,
                            isSuccess: true,
                            hasErrors: false
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: true
                        }
                    )
                }
            );

        case SHOW_PRODUCT_ACTION_ERROR:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, {
                            error: action.payload.error
                        }
                    )
                }
            );

        case HIDE_PRODUCT_ACTION_ERROR:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, {
                            // eslint-disable-next-line no-undefined
                            error: undefined
                        }
                    )
                }
            );

        case ADD_TO_CART_ERROR:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, {
                            error: action.payload.code
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: true
                        }
                    )
                }
            );

        case SHOW_CANNOT_ADD_TO_LIST_ERROR:
            // Set default error message
            let errorMsg = 'ERROR_PRODUCT_SLICE_ADD_TO_LIST';

            // If component has a list name and payload has an error build
            // an error code. Else, build code with just list name
            if (action.meta.component && action.meta.component.listName) {
                if (action.payload.error) {
                    errorMsg = `${action.payload.error}_${action.meta.component.listName}`;
                } else {
                    errorMsg = `ERROR_PRODUCT_SLICE_ADD_TO_${action.meta.component.listName}`;
                }
            }

            return Object.assign(
                {}, state, {
                    productListMessages: Object.assign(
                        {}, state.productListMessages, {
                            error: errorMsg
                        }
                    )
                }
            );

        case HIDE_CANNOT_ADD_TO_LIST_ERROR:
            return Object.assign(
                {}, state, {
                    productListMessages: Object.assign(
                        {}, state.productListMessages, {
                            // eslint-disable-next-line no-undefined
                            error: undefined
                        }
                    )
                }
            );

        case ADD_TO_WISHLIST_RESOLUTION:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, action.payload
                    ),
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            canAddToCart: true
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: true,
                            isPending: false,
                            isSuccess: true
                        }
                    )
                }
            );

        case MOVE_TO_WISHLIST_RESOLUTION:
            return Object.assign(
                {}, state, {
                    productMessages: Object.assign(
                        {}, state.productMessages, action.payload
                    ),
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            canAddToCart: true
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: true
                        }
                    )
                }
            );

        case CAN_ADD_TO_LIST:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            canAddToCart: action.payload.canAddToList
                        }
                    ),
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            canAddToWishList: action.payload.canAddToList
                        }
                    )
                }
            );

        case RECEIVE_REVIEWS:
            return Object.assign(
                {}, state, {
                    productReviews: Object.assign(
                        {}, state.productReviews, action.payload.productReviews
                    )
                }
            );

        case UPDATE_PRODUCT_REVIEW_STATS:
            return Object.assign({}, state, {
                    reviews: Object.assign({}, state.reviews, {
                        averageRating: action.payload.averageOverallRating,
                        averageFitRating: action.payload.averageFitRating,
                        count: action.payload.totalReviewCount
                    }),
                    productReviews: Object.assign({}, state.productReviews, {
                        TotalResults: action.payload.totalReviewCount,
                        averageRating: action.payload.averageOverallRating,
                        hasProductReviews: action.payload.totalReviewCount > 0
                    })
                }
            );

        case SAVE_PRODUCT_ERROR:
            return Object.assign(
                {}, state, action.error
            );

        case RECEIVE_UGC:
            return Object.assign(
                {}, state, {
                    ugc: action.payload.ugc
                }
            );

        case RECEIVE_WRITE_REVIEW_FIELDS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            fields: action.payload.fields,
                            uploadedImageUrls: [],
                            uploadedImageCaptions: []
                        }
                    )
                }
            );

        case WRITE_REVIEW_SUCCESS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            error: false
                        }
                    )
                }
            );

        case WRITE_REVIEW_AUTOFILL:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            autofill: action.payload
                        }
                    )
                }
            );

        case RECEIVE_WRITE_REVIEW_ERRORS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            error: true,
                            errorData: action.payload.errors
                        }
                    )
                }
            );

        case SAVE_WRITE_REVIEW_VALIDATION:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            validation: {
                                values: action.payload.values,
                                messages: action.payload.msgs
                            }
                        }
                    )
                }
            );

        case SAVE_DEFAULT_URBN_STORE:
            return Object.assign({}, state, {
                productBopis: Object.assign({}, state.productBopis, {
                    defaultStore: action.payload.productBopis.defaultStore
                })
            });

        case UPDATE_PRODUCT_META:
        case TOGGLE_NO_STORE_MESSAGE:
            return merge(
                state,
                action.payload
            );

        case SAVE_REQUEST_SWATCH_SELECTION_ERROR:
        case SAVE_REQUEST_SWATCH_SELECTIONS:
            return Object.assign({}, state, {
                productRequestSwatch: Object.assign({}, state.productRequestSwatch, action.payload)
            });

        case CHANGE_QUANTITY:
            return merge(
                state,
                action.payload,
                getBopisState(
                    state.productBopis.defaultStore,
                    action.payload.productBopis.quantity,
                    state.productBopis.selectedSku.sku,
                )
            );

        case SAVE_BOPIS_POOLS:
        case UPDATE_SELECTED_SKU:

            const bopisState = getBopisState(
                state.productBopis.defaultStore,
                state.productBopis.quantity,
                action.payload.productBopis.selectedSku.sku,
            );

            let returnValue = Object.assign(
                {}, state, {
                    productControls: Object.assign(
                        {}, state.productControls, action.payload.productControls
                    ),
                    productDetails: Object.assign(
                        {}, state.productDetails, action.payload.productDetails
                    ),
                    productMessages: Object.assign(
                        {}, state.productMessages, action.payload.productMessages
                    ),
                    productMeta: Object.assign(
                        {}, state.productMeta, action.payload.productMeta
                    ),
                    selectedSku: action.payload.selectedSku,
                    skuInfo: Object.assign(
                        {}, state.skuInfo, action.payload.skuInfo
                    ),
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, bopisState.productAddToCart
                    ),
                    productBopis: Object.assign(
                        {}, state.productBopis, action.payload.productBopis, bopisState.productBopis
                    )
                }
            );
            if (action.payload.hideListAddLinks !== undefined) {
                returnValue.hideListAddLinks = action.payload.hideListAddLinks;
            }
            return returnValue;

        case UPDATE_BOPIS_STOCK_INFO:
            return Object.assign(
                {}, state, {
                    productBopis: Object.assign(
                        {}, state.productBopis, {
                            stock: action.payload.productBopis.stock
                        }
                    )
                }
            );

        case SHOW_SHIP_TO_STORE_ERROR:
            return Object.assign({}, state, {
                productBopis: Object.assign({}, state.productBopis, {
                    showShipToStoreError: true
                })
            });

        case SET_REVIEW_PAGE:
        case UPDATE_REVIEW_PAGES:
            return Object.assign(
                {}, state, {
                    productReviews: Object.assign(
                        {}, state.productReviews, action.payload
                    )
                }
            );

        case EXPAND_IMAGE:
            return merge(
                state, {
                    expandedImage: action.payload
                }
            );

        case WRITE_REVIEW_IMAGE_UPLOAD_SUCCESS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            uploadedImageUrls: action.payload.urls,
                            uploadedImageCaptions: action.payload.captions
                        }
                    )
                }
            );

        case SAVE_PHOTO_UPLOAD_PREVIEW:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            uploadPreview: {
                                file: action.payload.file,
                                fileName: action.payload.fileName,
                                url: action.payload.url
                            }
                        }
                    )
                }
            );

        case RESET_PHOTO_UPLOAD_PREVIEW:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            uploadPreview: {},
                            uploadErrors: {}
                        }
                    )
                }
            );

        case DELETE_UPLOADED_PHOTO:
            const urls = state.productWriteReview.uploadedImageUrls;
            const captions = state.productWriteReview.uploadedImageCaptions;

            urls.splice(action.payload.loopIndex, 1);
            captions.splice(action.payload.loopIndex, 1);
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            lastChanged: String(Date.now()),        // Watchers don't fire when you change arrays
                            uploadedImageUrls: urls,
                            uploadedImageCaptions: captions
                        }
                    )
                }
            );

        case RECEIVE_WRITE_REVIEW_IMAGE_UPLOAD_ERRORS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            uploadErrors: {
                                error: true,
                                errorData: action.payload.errors
                            }
                        }
                    )
                }
            );

        case SAVE_WRITE_REVIEW_FORM_DATA:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            formData: action.payload.formData
                        }
                    )
                }
            );

        case RECEIVE_WRITE_REVIEW_FIELDS_ERRORS:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            fields: {
                                fieldsRequestError: true,
                                errorData: action.payload.errors
                            }
                        }
                    )
                }
            );

        case RESET_WRITE_REVIEW_FORM:
            return Object.assign(
                {}, state, {
                    productWriteReview: Object.assign(
                        {}, state.productWriteReview, {
                            // eslint-disable-next-line no-undefined
                            error: undefined,
                            errorData: {},
                            formData: {},
                            validation: {},
                            uploadPreview: {},
                            uploadedImageUrls: [],
                            uploadedImageCaptions: [],
                            uploadErrors: {}
                        }
                    )
                }
            );

        case BOPIS_CHANGE_STORE_LOAD_STORES:
            return Object.assign({}, state, {
                bopisChangeStore: Object.assign({}, state.bopisChangeStore, {
                    stores: action.payload.stores,
                    pools: action.payload.pools
                })
            });

        case BOPIS_CHANGE_STORE_CLEAR:
            return Object.assign({}, state, {
                bopisChangeStore: {}
            });

        case BOPIS_CHANGE_STORE_SEARCH_DATA:
            return mixin(
                state,
                {
                    bopisChangeStore: mixin(
                        state.bopisChangeStore,
                        {
                            search: {
                                data: action.payload.data,
                                msgs: action.payload.msgs
                            }
                        }
                    )
                }
            );

        case BOPIS_CHANGE_STORE_RESULT_DATA:
            return mixin(
                state,
                {
                    bopisChangeStore: mixin(
                        state.bopisChangeStore,
                        {
                            result: {
                                data: action.payload.data,
                                msgs: action.payload.msgs
                            }
                        }
                    )
                }
            );

        case SAVE_REQUEST_SWATCH_FORM_DATA:
            return Object.assign(
                {}, state, {
                    productRequestSwatch: Object.assign(
                        {}, state.productRequestSwatch, {
                            formData: Object.assign({},
                                state.productRequestSwatch.formData,
                                action.payload.formData
                            )
                        }
                    )
                }
            );

        case RESET_REQUEST_SWATCH_SELECTIONS:
            return Object.assign(
                {}, state, {
                    productRequestSwatch: Object.assign(
                        {}, state.productRequestSwatch, {
                            selectedCount: 0,
                            selectedSwatches: [],
                            swatchesString: '',
                            userInitiatedSelection: false,
                            selectedColorCode: {}
                        }
                    )
                }
            );

        case RESET_REQUEST_SWATCH_FORM_DATA:
            return Object.assign(
                {}, state, {
                    productRequestSwatch: Object.assign(
                        {}, state.productRequestSwatch, {
                            formData: {
                                firstName: '',
                                lastName: '',
                                streetAddress1: '',
                                streetAddress2: '',
                                city: '',
                                state: '',
                                zip: '',
                                email: ''
                            }
                        }
                    )
                }
            );

        case SET_SELECTED_PRODUCT_FOR_REQUEST_SWATCH:
            return Object.assign(
                {}, state, {
                    productRequestSwatch: Object.assign(
                        {}, state.productRequestSwatch, {
                            selectedProduct: action.payload.product,
                            swatches: action.payload.product.swatches,
                            selectedColorCode: action.payload.selectedColorCode
                        }
                    )
                }
            );

        case SET_REQUEST_SWATCH_COUNTRIES:
            return Object.assign(
                {}, state, {
                    productRequestSwatch: Object.assign(
                        {}, state.productRequestSwatch, {
                            countries: action.payload.countries,
                        }
                    )
                }
            );

        case BACK_IN_STOCK_NOTIFICATION_FAILURE:
            return Object.assign(
                {}, state, {
                    productControls: Object.assign(
                        {}, state.productControls, {
                            backInStockErrors: action.payload
                        }
                    )
                }
            );

        case SET_BACK_TO_CATALOG_URL:
            return Object.assign(
                {}, state, {
                    backToCatalogData: {
                        backToCatalogUrl: action.payload.backToCatalogUrl,
                        pageName: action.payload.pageName
                    }
                }
            );

        case ADD_TO_CART_READY:
            return Object.assign(
                {}, state, {
                    productAddToCart: Object.assign(
                        {}, state.productAddToCart, {
                            addToCartReady: true
                        }
                    )
                }
            );

        case RESET_WISHLISTS:
            return Object.assign(
                {}, state, {
                    productAddToWishList: Object.assign(
                        {}, state.productAddToWishList, {
                            wishlists: undefined
                        }
                    )
                }
            );

        // TODO: UW-14895 - remove when SS_PDPTILETYPE test is over
        case SET_TILE_TYPE_OVERRIDE:
            return Object.assign(
                {}, state, {
                    tileTypeOverride: action.payload.tileTypeOverride
                }
            );

        default:
            return state;
    }
}
/* eslint-enable complexity */
